export const getCroppedFile = async (
  image: HTMLImageElement,
  pixelCrop: { height: number; width: number; x: number; y: number },
  outputDimensions?: { height: number; width: number },
  quality = 1
) => {
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  const naturalWidth = (outputDimensions?.width || pixelCrop.width) * scaleX;
  const naturalHeight = (outputDimensions?.height || pixelCrop.height) * scaleY;

  const MAX_CANVAS_SIZE = 2048;
  const limitMultiplier = Math.min(1, MAX_CANVAS_SIZE / Math.max(naturalWidth, naturalHeight));

  const finalWidth = naturalWidth * limitMultiplier;
  const finalHeight = naturalHeight * limitMultiplier;

  const canvas = document.createElement('canvas');
  canvas.width = finalWidth;
  canvas.height = finalHeight;

  const context = canvas.getContext('2d');

  if (!context) throw new Error('Canvas context not found');

  context.drawImage(
    image,
    pixelCrop.x * scaleX,
    pixelCrop.y * scaleY,
    pixelCrop.width * scaleX,
    pixelCrop.height * scaleY,
    0,
    0,
    canvas.width,
    canvas.height
  );

  return new Promise<File>((resolve) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) throw new Error('Crop failed');

        resolve(new File([blob], 'cropped.jpg', { type: 'image/jpeg' }));
      },
      'image/jpeg',
      quality
    );
  });
};
